import React from "react";
import { Route, Routes } from "react-router-dom";
import AkfaIntegrationLayout from "../layout/akfa/AkfaIntegrationLayout";

function AkfaIntegrationPage() {
    return (
        <Routes>
            <Route path="/" element={<AkfaIntegrationLayout />} />
        </Routes>
    );
}

export default AkfaIntegrationPage;
